import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
    GET_CONTRACT_TEMPLATE_LIST, SET_CONTRACT_TEMPLATE_LIST,
    GET_CONTRACT_TEMPLATE_BY_ID, SET_CONTRACT_TEMPLATE_BY_ID, ADD_CONTRACT_TEMPLATE, ADD_CONTRACT_TEMPLATE_RESPONSE,
    UPDATE_CONTRACT_TEMPLATE, UPDATE_CONTRACT_TEMPLATE_RESPONSE, DELETE_CONTRACT_TEMPLATE, DELETE_CONTRACT_TEMPLATE_RESPONSE,
    GET_CONTRACT_TEMPLATE_LIST_ORGANISATION_ID
} from "./actionTypes";

export class GetContractTemplateList implements Action {
    readonly type = GET_CONTRACT_TEMPLATE_LIST;
}

export class GetContractTemplateListByOrganisationId implements Action {
    readonly type = GET_CONTRACT_TEMPLATE_LIST_ORGANISATION_ID;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data;
    }
}

export class SetContractTemplateList implements Action {
    readonly type = SET_CONTRACT_TEMPLATE_LIST;
    readonly payload = []
    constructor(contractTemplateList: Array<any>) {
        this.payload = contractTemplateList;
    }
}

export class GetContractTemplateById implements Action {
    readonly type = GET_CONTRACT_TEMPLATE_BY_ID;
    readonly payload: string = null;
    constructor(id) {
        this.payload = id
    }
}

export class SetContractTemplateById implements Action {
    readonly type = SET_CONTRACT_TEMPLATE_BY_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class AddContractTemplate implements Action {
    readonly type = ADD_CONTRACT_TEMPLATE;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data;
    }
}

export class AddContractTemplateResponse implements Action {
    readonly type = ADD_CONTRACT_TEMPLATE_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export class UpdateContractTemplate implements Action {
    readonly type = UPDATE_CONTRACT_TEMPLATE;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data;
    }
}

export class UpdateContractTemplateResponse implements Action {
    readonly type = UPDATE_CONTRACT_TEMPLATE_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export class DeleteContractTemplate implements Action {
    readonly type = DELETE_CONTRACT_TEMPLATE;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data;
    }
}

export class DeleteContractTemplateResponse implements Action {
    readonly type = DELETE_CONTRACT_TEMPLATE_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export type Actions = GetContractTemplateList | SetContractTemplateList | GetContractTemplateById | SetContractTemplateById | AddContractTemplate
    | AddContractTemplateResponse | UpdateContractTemplate | UpdateContractTemplateResponse | DeleteContractTemplate | DeleteContractTemplateResponse;
